module.exports = __webpack_public_path__ + "static/img/ikonaGaleria-ON.98de7e85.png";